export default __webpack_public_path__ + "static/media/mo-lottery-trained-variants.d3eaeb18.webp";